import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcListConfig} from 'exc-controls';
import {ExcSigninService} from 'exc-signin';
import {ModalNewReviewResultComponent} from '../modals/modal-new-review-result/modal-new-review-result.component';
import {ExcReport, ExcReportAbo, ExcReportAboTemplate, ReportService} from '../report-service.service';
import {ExcFileItem} from '../attachments/models/ExcFileItem';
import {DataImportUploadConfirmModalComponent} from '../data-import-upload-confirm-modal/data-import-upload-confirm-modal.component';


@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styles: []
})
export class ConfigComponent extends ExcTranslation implements OnInit {
  state: number;
  menuItem = [{id: 1, cat: 'ImportTitle', icon: 'upload', token: 'CLI_IMP_CU'} ,
    // {id: 2, cat: 'ExportTitle', icon: 'download', token: null} ,
    {id: 2, cat: 'ConfigTitle', icon: 'tools', token: 'CLI_CFG_R'},
    {id: 3, cat: 'AuditResult', icon: 'file-alt', token: 'CLI_CFG_R'} ,
    {id: 4, cat: 'ReviewResult', icon: 'file-signature', token: 'CLI_CFG_R'},
    {id: 5, cat: 'SelfcheckConfig', icon: 'file-alt', token: 'CLI_CFG_R'} ,
    {id: 6, cat: 'ReportConfig', icon: 'file-chart-pie', token: 'CLI_RPT_CU'},
    {id: 7, cat: 'ReportAbo', icon: 'mail-bulk', token: 'CLI_RPT_CU'} ];
  configData: any;
  isLoading = false;
  Data: any;

  UUID = ExcCoreModule.Guid.NewGuid();
  UUID2 = ExcCoreModule.Guid.NewGuid();
  UUID3 = ExcCoreModule.Guid.NewGuid();

  initConfigData: any;
  initAuditResultData: any;
  initReviewResultData: any;

  ratingListConfig: ExcListConfig = new ExcListConfig();
  configListData: any[] = [];
  SearchValue = '';

  Rating;

  auditResultListConfig: ExcListConfig = new ExcListConfig();
  auditResultListData: any[];
  auditResultData: any;

  reviewResultListConfig: ExcListConfig = new ExcListConfig();
  reviewResultListData: any[];
  reviewResultData: any;

  clientID = 0;
  auditCodeIsCritical = false;
  auditCodeIsOK = false;

  reviewCodeIsCritical = false;
  reviewCodeIsOK = false;

  lang = '';
  @ViewChild('menuPopup') menuPopup;
  languages = [
    {value: 'de', text: this.getRessource('DE')},
    {value: 'en', text: this.getRessource('EN')},
    {value: 'fr', text: this.getRessource('FR')},
  ];

  reports: ExcReport[] = [];
  abos: ExcReportAbo[] = [];
  reportAboTemplates: ExcReportAboTemplate[] = [];
  constructor(private excrest: ExcRestService, private ref: ChangeDetectorRef , private excSec: ExcSigninService, private reportService: ReportService) {
    super();
    const _self = this;
    _self.ratingListConfig.OnSearch = (searchValue) => {
      _self.SearchValue = searchValue;
      _self.loadConfigs();
    };
    _self.ratingListConfig.OnRefresh = (event) => {
      _self.loadConfigs();
    };
    _self.ratingListConfig.OnSelectionChanged = (selectedItems, event1) => {
      if (!selectedItems || selectedItems.length !== 1) {
        _self.configData = selectedItems[0];
        _self.Rating = undefined;
        return;
      }
      _self.loadDetails(selectedItems[0]);
      _self.Rating = selectedItems[0].jpkRating;
    };
    _self.ratingListConfig.selectFirstAfterInit = true;

    _self.auditResultListConfig.OnSearch = (searchValue) => {
      _self.SearchValue = searchValue;
      _self.loadConfigs();
    };
    _self.auditResultListConfig.OnRefresh = (event) => {
      _self.loadConfigs();
    };
    _self.auditResultListConfig.OnSelectionChanged = (selectedItems, event1) => {
      _self.auditResultData = selectedItems[0];
      _self.initAuditResultData = Object.assign({}, selectedItems[0]);
      _self.auditCodeIsCritical = _self.auditResultData.CodeIsCritical;
      _self.auditCodeIsOK = _self.auditResultData.CodeIsOk;
    };
    _self.auditResultListConfig.selectFirstAfterInit = true;
    // _self.reviewResultListConfig.MetaInfo.dataSort['ReviewCodeValidFrom'] = 'Desc';
    _self.reviewResultListConfig.OnSearch = (searchValue) => {
      _self.SearchValue = searchValue;
      _self.loadConfigs();
    };
    _self.reviewResultListConfig.OnRefresh = (event) => {
      _self.loadConfigs();
    };
    _self.reviewResultListConfig.OnSelectionChanged = (selectedItems, event1) => {
      _self.reviewResultData = selectedItems[0];
      _self.initReviewResultData = Object.assign({}, selectedItems[0]);
      _self.reviewCodeIsCritical = _self.reviewResultData.ReviewCodeIsCritical;
      _self.reviewCodeIsOK = _self.reviewResultData.ReviewCodeIsOK;
    };
    _self.reviewResultListConfig.OnDelete = (selectedItems) => {
      _self.deleteReviewResult(selectedItems);
    };
    _self.reviewResultListConfig.OnAdd = (event1) => {
      _self.openReviewResultModal(_self.clientID, _self.lang);
    };
    _self.reviewResultListConfig.selectFirstAfterInit = true;
  }

  ngOnInit() {
    const _self = this;
    _self.lang = _self.translateService.currentLang;
    _self.clientID = _self.Data.data.Mdt_Id;
    _self.loadConfigs();
    _self.stateChange(1);
  }

  menuItemChange(data) {
    const _self = this;
    _self.state = data;
  }

  loadConfigs() {
    const _self = this;
    const metainfo = {
      dataFilter: {ReviewCodeCulture: _self.lang},
    };
    // _self.ratingListConfig.isLoading = true;
    _self.excrest.sget(this.excrest.computeUrl('ConfigR_Summary',
        {
          fts: _self.SearchValue,
          mandantID: _self.clientID}),
      ExcCoreModule.Guid.NewGuid(), {MetaInfo: metainfo})
      .subscribe(response => {
        if (response.response !== undefined && response.response !== null) {
          _self.configListData = response.response.Rating;
          _self.auditResultListData = response.response.AuditResult;
          _self.reviewResultListData = response.response.ReviewResult;
          /* _self.Rating =  _self.configListData[0].Rating;
           _self.configListConfig.paging = response.response.paging;*/
        }
        if ( response.response.AuditResult.length === 0) {
          _self.auditResultData = null;
        }
        if ( response.response.ReviewResult.length === 0) {
          _self.reviewResultData = null;
        }
        _self.reports = [];
        for (const r of response.response.Reports) {
          _self.reports.push(ExcReport.Parse(r));
        }
        for (const r of response.response.Abos) {
          _self.abos.push(ExcReportAbo.Parse(r));
        }
        for (const r of response.response.AboTemplates) {
          _self.reportAboTemplates.push(ExcReportAboTemplate.Parse(r));
        }
      });
  }

  loadDetails(data) {
    const _self = this;
    _self.configData = data;
    _self.initConfigData = Object.assign({}, data);
  }

  updateConfig(data) {
    const _self = this;
    _self.excrest.put(_self.excrest.computeUrl('ConfigU', {clID: _self.clientID, rating: data.jpkRating}), {
      jpkFloorcheckAnnounced: data.jpkFloorcheckAnnounced,
      jpkFloorcheckIncludeDocuments: data.jpkFloorcheckIncludeDocuments,
      jpkSelfcheckAnnouncementDays: data.jpkSelfcheckAnnouncementDays,
      jpkSelfcheckQuota: data.jpkSelfcheckQuota,
      jpkSelfcheckQuotaMin: data.jpkSelfcheckQuotaMin,
      jpkSelfcheckQuotaMax: data.jpkSelfcheckQuotaMax,
      jpkSelfcheckDuration: data.jpkSelfcheckDuration,
      jpkSelfcheckIncludeDocuments: data.jpkSelfcheckIncludeDocuments,
      jpkSelfcheckFullCheck: data.jpkSelfcheckFullCheck,
      jpkValidFrom: data.jpkValidFrom,
      jpkValidTo: data.jpkValidTo
    }, {}, false).subscribe(response => {
      // Att
      _self.initConfigData = Object.assign({}, _self.configData);
      _self.loadConfigs();
    });
  }

  stateChange(data) {
    const _self = this;
    _self.state = data;
  }

  resetForm() {
    const _self = this;
    _self.configData = [];
    _self.configData.jpkRating = _self.Rating;
    _self.configData.jpkValidFrom = new Date();
  }

  updateAuditResult(data) {
    const _self = this;
    _self.excrest.put(_self.excrest.computeUrl('ConfigAuditResultU', {mandantID: _self.clientID}), {
      mandantID: _self.clientID,
      CodeID: data.CodeID,
      CodeLong: data.CodeLong,
      CodeObjectSeen: data.CodeObjectSeen,
      CodeIsOk: _self.auditCodeIsOK,
      CodeIsCritical: _self.auditCodeIsCritical,
      CodeDescription: data.CodeDescription
    }, {}, false).subscribe(response => {
      _self.loadConfigs();
      _self.initAuditResultData = Object.assign({}, _self.auditResultData);
    });
  }

  updateReviewResult() {
    const _self = this;
    _self.excrest.put(_self.excrest.computeUrl('ConfigReiewResultU', {mandantID: _self.clientID}), {
      mandantID: _self.clientID,
      ReviewCodeID: _self.reviewResultData.ReviewCodeID,
      ReviewCodeText: _self.reviewResultData.ReviewCodeText,
      ReviewCodeCulture: _self.lang,
      ReviewCodeIsOK: _self.generateBitValue(_self.reviewResultData.ReviewCodeIsOK),
      ReviewCodeIsCritical: _self.generateBitValue(_self.reviewResultData.ReviewCodeIsCritical)
    }, {}, false).subscribe(response => {
      _self.loadConfigs();
      _self.initReviewResultData = Object.assign({}, _self.reviewResultData);
    });
  }

  toggleAuditCheckBoxes(name) {
    const _self = this;
    if (_self.auditResultData.AuditCodeIsOK && name === 'IsOK') {
      _self.auditResultData.AuditCodeIsCritical = false;
    }
    if (_self.auditResultData.AuditCodeIsCritical && name === 'IsCritical') {
      _self.auditResultData.AuditCodeIsOK = false;
    }
    if (_self.reviewResultData.ReviewCodeIsOK && name === 'rIsOK') {
      _self.reviewResultData.ReviewCodeIsCritical = false;
    }
    if (_self.reviewResultData.ReviewCodeIsCritical && name === 'rIsCritical') {
      _self.reviewResultData.ReviewCodeIsOK = false;
    }

  }

  toggleLangResult() {
    const _self = this;
    if (_self.lang === 'de') {
      _self.lang = 'en';
      _self.loadConfigs();
      return;
    }
    if (_self.lang === 'en') {
      _self.lang = 'de';
      _self.loadConfigs();
      return;
    }
  }

  setLang(culture, e) {
    const _self = this;
    _self.lang = culture;
    /* _self.configData = null;
     _self.configListData = [];*/
    _self.reviewResultData = null;
    _self.loadConfigs();
    this.hideMenuPopup(e);
  }

  showMenuPopup (event) {
    const _self = this;
    this.menuPopup.show(event);
  }

  hideMenuPopup(event) {
    this.menuPopup.hide(event);
  }
  getSeenClass(data) {
    if (data.CodeObjectSeen === null) {
      return '';
    }
    if (data.CodeObjectSeen === true) {
      return 'th-success fa-eye';
    } else {
      return 'th-danger fa-eye-slash';
    }
  }
  getSeenTooltip(data) {
    const _self = this;
    if (data.CodeObjectSeen === null) {
      return '';
    }
    if (data.CodeObjectSeen === true) {
      return  _self.getRessource('IsSeen');
    } else {
      return _self.getRessource('IsNotSeen');
    }
  }
  isConfigOriginal() {
    const _self = this;
    return JSON.stringify(_self.initConfigData) === JSON.stringify(_self.configData);
  }
  isAuditResultOriginal() {
    const _self = this;
    return JSON.stringify(_self.initAuditResultData) === JSON.stringify(_self.auditResultData);
  }
  isReviewResultOriginal() {
    const _self = this;
    return JSON.stringify(_self.initReviewResultData) === JSON.stringify(_self.reviewResultData);
  }
  deleteReviewResult (selectedItems) {
    const _self = this;
    const requests = [];
    selectedItems.forEach(item => {
      requests.push(_self.excrest.delete(_self.excrest.computeUrl('ConfigReiewResultD' , {clID: 0 }),
        {
          mandantID: _self.clientID,
          ReviewCodeID: item.ReviewCodeID
        }, {}, false).subscribe(response => {
        _self.loadConfigs();
      }));
    });
  }
  openReviewResultModal (ClID, Cult) {
    const _self = this;
    ExcCoreModule.call('eOS.showModal', ModalNewReviewResultComponent,
      {
        settings: {
          header: false,
          footer: false,
          size: 'm',
          closableViaOverlay: false,
          onClose: (result) => {
            if (result.proceed) {
              _self.excrest.post(_self.excrest.computeUrl('ConfigReiewResultC',
                  {
                    mandantID: result.obj.mandantID
                  }),
                {
                  mandantID: result.obj.mandantID,
                  ReviewCodeText:  result.obj.ReviewCodeText,
                  ReviewCodeCulture:  result.obj.ReviewCodeCulture,
                  ReviewCodeIsOK: _self.generateBitValue( result.obj.ReviewCodeIsOK),
                  ReviewCodeIsCritical: _self.generateBitValue( result.obj.ReviewCodeIsCritical)
                }, {})
                .subscribe(response => {
                  _self.loadConfigs();
                });
            }
          }
        },
        data: {clID: ClID , cult: Cult}
      }
    );
  }
  generateBitValue (val) {
    if (val === true) {
      return 1;
    } else {
      return 0;
    }
  }
  downloadReportTemplate(r: ExcReport) {
    this.reportService.DownloadTemplate(r.rptID);
  }
  editReport(r: ExcReport) {
    const _self = this;
    _self.reportService.Edit(r).subscribe(ret => {
      if (ret !== null) {
        for (let i = 0; i < _self.reports.length; i++) {
          if (_self.reports[i].rptID === ret.rptID) {
            _self.reports[i] = ret;
            break;
          }
        }
      }
    });
  }
  uploadReportTemplate(e, r: ExcReport) {
      const _self = this;
      const file: ExcFileItem = e[0];
      _self.reportService.UploadTemplate(r, file).subscribe(ret => {
        if (ret !== null) {
          r.rptTemplateType = ret['rptTemplateType'];
        }
      });
  }
  addReportAbo() {
      this.reportService.ShowAboEditModal(new ExcReportAbo(), this.reports, this.reportAboTemplates).subscribe(x => {
        this.abos = x;
      });
  }
  editReportAbo(a: ExcReportAbo) {
    this.reportService.ShowAboEditModal(a, this.reports, this.reportAboTemplates).subscribe(x => {
      this.abos = x;
    });
  }
  deleteReportAbo(a: ExcReportAbo) {
    this.reportService.ShowAboDeleteModal(a).subscribe(x => {
      this.abos = x;
    });
  }

}
